import i18n from '../../lang/index'
const ddoscdnRouter = [{
  path: '/ddoscdn',
  component: () => import('@/pages/Index'),
  redirect: {
    name: 'ddoscdnindex'
  },
  children: [{
      name: 'ddoscdnindex',
      path: 'index',
      component: () => import('@/pages/ddoscdn/Index'),
      redirect: {
        name: 'antiddosCdn'
      },
      children: [{
          name: 'antiddosCdn',
          path: 'antiddos',
          meta: {
            tab: 'antiddos',
            title: i18n.t('ddoscdn.titles.antiDdosIP')
          },
          component: () => import('@/pages/ddoscdn/AntiDDoS'),
        },
        {
          name: 'web',
          path: 'web',
          meta: {
            tab: 'web',
            title: i18n.t('ddoscdn.titles.web')
          },
          component: () => import('@/pages/ddoscdn/WebSite'),
        }
      ]
    },
    {
      name: 'antset',
      path: 'antiddos/set',
      component: () => import('@/pages/ddoscdn/IPSetView'),
    },
    {
      name: 'ipdetail',
      path: 'antiddos/detail',
      component: () => import('@/pages/ddoscdn/IPView'),
    },
    {
      name: 'domset',
      path: 'web/set',
      component: () => import('@/pages/ddoscdn/DomainSetView'),
    },
    {
      name: 'frequencyRules',
      path: 'rule/frequency',
      component: () => import('@/pages/ddoscdn/FrequencyRules'),
    },
    {
      name: 'preciseRules',
      path: 'rule/precise',
      component: () => import('@/pages/ddoscdn/PreciseRules'),
    },
    {
      name: 'accelerationRules',
      path: 'rule/acceleration',
      component: () => import('@/pages/ddoscdn/AccelerationRules'),
    },
    {
      name: 'refreshUrl',
      path: 'set/refresh',
      component: () => import('@/pages/ddoscdn/RefreshCache'),
    },
    {
      name: 'logindex',
      path: 'log',
      component: () => import('@/pages/ddoscdn/IndexLog'),
      redirect: {

        name: 'fulllog_ddoscdn'
      },
      children: [{
        name: 'fulllog_ddoscdn',
        path: 'fullLog',
        meta: {
          tab: 'fullLog',
          title: i18n.t('ddoscdn.titles.fullLog')
        },
        component: () => import('@/pages/ddoscdn/FullLog'),

      }, {
        name: 'Visitslog',
        path: 'visits',
        meta: {
          tab: 'visits',
          title: i18n.t('ddoscdn.titles.ipVisits')
        },
        component: () => import('@/pages/ddoscdn/VisitsLog'),
      }, {
        name: 'Regionlog',
        path: 'region',
        meta: {
          tab: 'region',
          title: i18n.t('ddoscdn.titles.ipRegionRanking')
        },
        component: () => import('@/pages/ddoscdn/RegionLog'),
      }, {
        name: 'Ranklog',
        path: 'rank',
        meta: {
          tab: 'rank',
          title: i18n.t('ddoscdn.titles.ipRanking')
        },
        component: () => import('@/pages/ddoscdn/RankLog'),
      }, {
        name: 'Urllog',
        path: 'url',
        meta: {
          tab: 'url',
          title: i18n.t('ddoscdn.titles.urlLog')
        },
        component: () => import('@/pages/ddoscdn/UrlLog'),
      },{
        name: 'FeaturesLog',
        path: 'features',
        meta: {
          tab: 'features'
        },
        component: () => import('@/pages/ddoscdn/FeaturesLog'),
      }, {
        name: 'LayerLog',
        path: 'layerlog',
        meta: {
          tab: 'layerlog'
        },
        component: () => import('@/pages/ddoscdn/LayerLog'),
      }, {
        name: 'LayerChart',
        path: 'layerchart',
        meta: {
          tab: 'layerchart'
        },
        component: () => import('@/pages/ddoscdn/LayerChart'),
      }, {
        name: 'AttackLog',
        path: 'attack',
        meta: {
          tab: 'attack'
        },
        component: () => import('@/pages/ddoscdn/AttackLog'),
      }, ]
    },
  ]
}]
export default ddoscdnRouter



// WEBPACK FOOTER //
// ./src/router/modules/ddoscdn.js